import { FieldAttributes, useField } from 'formik'
import { Form } from 'react-bootstrap'
import InputErrorWrapper from '../InputErrorWrapper'

// eslint-disable-next-line
const PasswordInput: React.FC<FieldAttributes<any>> = ({ touched, ...props }): JSX.Element => {
    const [field, meta] = useField(props)

    return (
        <InputErrorWrapper meta={meta} testId={props.name}>
            <Form.Control
                type="password"
                {...field}
                {...props}
                value={field.value || ''}
                isInvalid={!!meta.error && meta.touched}
                isValid={!meta.error && meta.touched}
                data-testid={`formPasswordInput_${props.name}`}
            />
        </InputErrorWrapper>
    )
}

export default PasswordInput
